import React from 'react'
import SavingsIcon from '@mui/icons-material/Savings';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import TimelineIcon from '@mui/icons-material/Timeline';
import Forms from '../Forms';
import Header from '../Header';
import Footer from '../Footer';
import heropic from '../../images/pic.png'




const Adver = () => {
  return (
    <div className=''>
      <Header/>
      <div className="h-full ">
        <div className="chose bg-gray-800 text-white md:flex-row flex justify-between items-center w-full p-10 max-sm:flex-col">
          <div className="l w-4/5">
            <div className="hed pt-10">
              <h1 className="text-8xl font-semibold">Why Choose Us!</h1>
            </div>
            <div className="desc mt-10  mr-5">
              <p className='text-xl'>Our agency promotes your brand on custom water bottles, distributed free to consumers.</p>
              <p className="mt-4 text-xl"> This unique strategy ensures your brand is always in hand, creating a lasting impression and adding value to everyday experiences. It’s advertising that refreshes and resonates.</p>
            </div>

          </div>
          <div className="r  md:w-3/5 max-sm:w-96 max-sm:mt-20">
            <div className="img max-sm:m-auto">
              <img src={heropic} alt="" />
            </div>

          </div>
        </div>
        <div className="advantage  mt-10 p-10 max-sm:p-0 ">
          <div className="md:flex justify-around items-center  gap-5 w-full max-sm:flex-col md:flex-row">
            <div className="w-1/3 bg-gray-800 max-sm:w-3/5 text-white max-sm:my-5 max-sm:p-10 max-sm:m-auto">
              <QrCodeScannerIcon sx={{ fontSize: 90 }} className=" hover:text-black z-50 w-full  mb-2" />
              <h1 className='text-3xl font-semibold '>QR-Code Integration</h1>
              <p className='mt-2'>Integrate QR codes on labels for instant access to brand info, promotions, or interactive content, enhancing consumer engagement.</p>
            </div>
            <div className="w-1/3 bg-gray-800 max-sm:w-3/5 text-white max-sm:my-5 max-sm:p-10 max-sm:m-auto">
              <TimelineIcon sx={{ fontSize: 90 }} className=" hover:text-black  mb-2" />
              <h1 className='text-3xl font-semibold '>Scale your Visibility</h1>
              <p className="mt-2">By placing your brand directly in consumers' hands,, turning every sip into a brand experience and expanding your reach effectively.</p>
            </div>
            <div className="w-1/3 bg-gray-800 max-sm:w-3/5 text-white max-sm:my-5 max-sm:p-10 max-sm:m-auto">
              <SavingsIcon sx={{ fontSize: 90 }} className=" hover:text-black mb-2" />
              <h1 className='text-3xl font-semibold '>Save Money</h1>
              <p className="mt-2">By leveraging this cost-effective strategy, you turn everyday items into powerful promotional tools, reducing the need for expensive advertising channels </p>

            </div>
          </div>

        </div>
        <Forms/>
      
      </div>
      <Footer/>
    </div>
  )
}

export default Adver